import React from "react";
import head from "../../../../img/headers/tariffe.jpg";
import Container from "react-bootstrap/Container";

function Tariffe(){
    require("./tariffe.css"); // here
    return(
        <>

            <Container className="pb-3">
            <img src={head} alt="Le tariffe - Mano nella mano, asilo nido a Mariano Comense in provincia di Como" className="img-fluid pb-3"/>

                <h2 className="text-center title">Tariffe</h2>

                <p className="pt-2"><u>Iscrizione annuale non rimborsabile</u>, comprensiva di mantenimento posto e apertura cartella del bambino: € 152,00.</p>

                <div className="table-responsive">
                    <table className="table table-bordered caption-top myTable">
                        <thead>
                            <tr className="">
                                <th scope="col"><b>PART-TIME</b></th>
                                <th scope="col"><b>FULL-TIME</b></th>
                                <th scope="col"><b>POST NIDO</b></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Entrata 7.30-9.00</td>
                                <td>Entrata 7.30-9.00</td>
                                <td>Entrata 7.30-9.00</td>
                            </tr>
                            <tr>
                                <td>Uscita 12.30-13.00</td>
                                <td>Uscita 16.00-16.30</td>
                                <td>Uscita 16.30-18.30</td>
                            </tr>
                            <tr>
                                <td>€ 552,00</td>
                                <td>€ 652,00</td>
                                <td>€ 702,00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div className="table-responsive">
                    <table className="table table-bordered caption-top text-center">
                        <thead>
                            <tr>
                                <th colSpan={3}><b>PART-TIME POMERIDIANO 5 giorni</b></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Entrata 12.30-13.00</td>
                                <td>Entrata 12.30-13.00</td>
                                <td>Entrata 12.30-13.00</td>
                            </tr>
                            <tr>
                                <td>Uscita 16.00-16.30</td>
                                <td>Uscita 16.30-17.30</td>
                                <td>Uscita 17.30-18.30</td>
                            </tr>
                            <tr>
                                <td>€ 422,00</td>
                                <td>€ 442,00</td>
                                <td>€ 472,00</td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <p>Le rette sono comprensive di:</p>

                <ul className="baloons">
                    <li>Copertura assicurativa;</li>
                    <li>Pannolini e prodotti per l’igiene del bambino ecologici e naturali;</li>
                    <li>Materiale didattico;</li>
                    <li>Pasti;</li>
                    <li>Colloqui trimestrali con le educatrici;</li>
                </ul>

            </Container>
        </>
    )
}

export default Tariffe;